
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';

const clone= require('lodash/clone');

@Injectable()
export class ControlledVocabularyService {
    constructor(@Inject('$location') private $location: ng.ILocationService) {
    }

    public getStateParams(){
        let params= clone(this.$location.search());
        params.facet= null;
        params.conVoc = 'false';
        return params;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/controlledVocabulary/controlledVocabulary.service.ts